import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useMemo } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { getTechAwarenessData } from "../../../../api/brandPerformanceApi";
import BrandPerformanceTrendTile from "../BrandPerformanceTrendTile";
import { applyEPowerSeriesColor } from "./techAwarenessColors";

interface Props extends RouteComponentProps {
  diff: number;
  granularity: string;
}

// Chart-only tab, unlike Purchase Funnel (which also shows an Awareness/Consideration table) -
// per the request, this only needs the one trendline.
const TechAwarenessContent = withRouter((props: Props) => {
  const { diff, history, granularity } = props;

  const params = useSelector((state: RootStateOrAny) => state.parameters);

  const {
    data: techAwarenessTrendData,
    isFetching: loadingTechAwarenessTrendData,
    refetch: refetchTechAwarenessTrendData,
  } = useQuery(["techAwarenessTrendData", granularity, history.location.search], () => getTechAwarenessData(params), { enabled: false });

  // when the url changes, refetch the data
  useEffect(() => {
    refetchTechAwarenessTrendData();
  }, [history.location.search]);

  // ePower must always render red regardless of position - every other series (E-Tech, Hybrid,
  // eHybrid) falls back to BrandPerformanceTrendChart's own palette-by-position default.
  const chartData = useMemo(
    () => ({
      ...techAwarenessTrendData,
      series: applyEPowerSeriesColor(techAwarenessTrendData?.series),
    }),
    [techAwarenessTrendData]
  );

  return (
    <div className="tech-awareness-main-content">
      <BrandPerformanceTrendTile
        title={`${params.competitor} Tech Awareness`}
        chartId="techAwarenessChart"
        chartData={chartData}
        loadingTrend={loadingTechAwarenessTrendData}
        diff={diff}
        isPercentage={true}
        numberFormat="#.0"
        chartGranularity={granularity}
      />
    </div>
  );
});

export default TechAwarenessContent;
